import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { ApiResponse, handleAxiosError } from "./responses/AxiosResponseHandler";

class DeleteOfferApi {
  private authClient: AuthClient;

  constructor(authClient: AuthClient) {
    this.authClient = authClient;
  }

  public async deleteOffer(offerId: string): Promise<ApiResponse<void> | undefined> {
    try {
      const authenticationResponse = this.authClient.getAuthenticationResponse();
      if (!authenticationResponse) {
        return undefined;
      }

      const response = await axios.delete(
        `${this.authClient.getApiRoot()}/offers/${offerId}`,
        {
          headers: {
            Authorization: `Bearer ${authenticationResponse.token}`,
          },
        }
      );

      return {
        statusCode: response.status,
        errorMessage: "",
      };
    } catch (error) {
      const errorResponse = handleAxiosError<void>(error as AxiosError);
      return {
        statusCode: errorResponse.statusCode,
        errorMessage: errorResponse.errorMessage,
        data: errorResponse.data,
      };
    }
  }
}

export default DeleteOfferApi;
